import type { ComponentProps } from "react";
import { styled } from "tamagui";
import { Progress as TamaguiProgress } from "@tamagui/progress";
const StyledProgress = styled(TamaguiProgress, {
  backgroundColor: "$surface0Hover",
  borderRadius: "$brFull",
  height: "$si0.75",
  overflow: "hidden",
  width: "100%",
  // Tamagui's Progress `size` variant sets a minWidth floor (size * 20).
  // Zero it out so the bar can be constrained by its parent.
  minWidth: 0
});
const StyledIndicator = styled(TamaguiProgress.Indicator, {
  backgroundColor: "$surfaceStrong",
  borderRadius: "$brFull"
});
type StyledProgressProps = ComponentProps<typeof StyledProgress>;
export type ProgressBarProps = Omit<StyledProgressProps, "value"> & {
  /**
   * Current progress value (0–100).
   */
  value: number;
  /**
   * Accessible label describing the progress.
   * Defaults to a percentage string (e.g. "50%").
   */
  getValueLabel?: (value: number, max: number) => string;
};
export const ProgressBar = ({
  value,
  getValueLabel,
  ...rest
}: ProgressBarProps) => {
  return <StyledProgress {...rest} value={value} getValueLabel={getValueLabel} data-sentry-element="StyledProgress" data-sentry-component="ProgressBar" data-sentry-source-file="ProgressBar.tsx">
      <StyledIndicator transition="300ms ease" data-sentry-element="StyledIndicator" data-sentry-source-file="ProgressBar.tsx" />
    </StyledProgress>;
};